import { request, queryString } from '../util'

const url = '/private/api/dashboard'

export default {
  getDashboardData (filter) {
    return request(`${url}${queryString.stringify({ filter: JSON.stringify(filter) })}`)
  }
}
